export class PreSaleUpgradeRequest {
  enrolmentId: string;
  cardId: string;
  acceptedTermsAndConditions: boolean;
  termsAndConditionsPolicyId: string;
  paymentIntentId: string;
  quotedAmount: number;
}
